import React, { useEffect, useState } from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { getBenchByListingDate } from '../API/TdsatApi';
import { format } from 'date-fns';
import { isValid } from 'date-fns';
import { RequiredLabel } from 'features/loginTdsat/Signup';

const useStyles = makeStyles((theme) => ({
  label: {
    color: '#121212',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
  
}));

const CourtNumberInput = ({courtNumber, onChange, listingDate, isRequired=false, size='medium', benchNature='', hideIfNoBench = false}) => {
  const classes = useStyles();

  const [courtNumberOptions, setCourtNumberOptions] = useState([]);
  const [noCourtNumberFound, setNoCourtNumberFound] = useState(false);
  const [benchList, setBenchlist] = useState([]);

  useEffect(()=>{
    if(listingDate && isValid(new Date(listingDate))){
      getCourtNumberList(listingDate);
    }
  },[listingDate])

  useEffect(() => {
    if(benchNature){
      setCourtNumberOptions(benchList?.filter(item => item?.bench_nature === benchNature) || []);
    }else {
      setCourtNumberOptions([...benchList] || []);
    }
  },[benchNature])

  const getCourtNumberList = (listingDate) => {
    setNoCourtNumberFound(false);
    const formatedDate = format(listingDate, 'dd-MM-yyyy')
    getBenchByListingDate(formatedDate).then((res)=>{
      // console.log('Court',res?.data);
      setCourtNumberOptions(res?.data);
      setBenchlist(res?.data);
      if(res?.data?.length === 0){
        setNoCourtNumberFound(true);
      }
    }).catch((error)=>{
      console.log('There is a glitch in getting court number: ',error);
    })
  }

  if (hideIfNoBench && noCourtNumberFound) {
    return null;
  }
  
  return (
    <>
      <FormControl required={isRequired} size={size} fullWidth margin="none" variant="outlined">
        {isRequired ? (
          <RequiredLabel className={classes.label} label={'Court Number'} />
        ) : (
          <Typography className={classes.label}>Court Number </Typography>
        )}
        <Select
          name="courtNumber"
          value={courtNumber}
          onChange={onChange}
          disabled={!listingDate}
        >
          <MenuItem>Select</MenuItem>
          {courtNumberOptions?.map((item)=>{
            return (
              <MenuItem key={item?.id} value={item?.court_number}>{item?.court_number}</MenuItem>
            )
          })}
        </Select>
        {(!hideIfNoBench && noCourtNumberFound) && <Typography align='left' color='error'>{'No bench is created on this listing date. Please select another date.'}</Typography>}
      </FormControl>
    </>
  );
};

export default CourtNumberInput;
